import { render, staticRenderFns } from "./MyAggsList.vue?vue&type=template&id=1929b6ba&scoped=true"
import script from "./MyAggsList.vue?vue&type=script&lang=js"
export * from "./MyAggsList.vue?vue&type=script&lang=js"
import style0 from "./MyAggsList.vue?vue&type=style&index=0&id=1929b6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1929b6ba",
  null
  
)

export default component.exports